/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Categories_IntroInputs */

const en_matching_score_categories_intro = /** @type {(inputs: Matching_Score_Categories_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individual scores in the following categories:`)
};

const de_matching_score_categories_intro = /** @type {(inputs: Matching_Score_Categories_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelwerte in folgenden Kategorien:`)
};

/**
* | output |
* | --- |
* | "Individual scores in the following categories:" |
*
* @param {Matching_Score_Categories_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_categories_intro = /** @type {((inputs?: Matching_Score_Categories_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Categories_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_categories_intro(inputs)
	return en_matching_score_categories_intro(inputs)
});